import '../../../scss/forms.scss';
import '../../../scss/print.scss';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import {
  Card, CardBody, CardHeader, Col, Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { FiltroDinamico, GridDinamico, dynamicFilterStore } from '@newspacebpo/newspace-react-grid-filter-bfveic';

import PrintCapa from '../../printCapa';
import { LOGS } from '../../../constants/logs';
import * as LogsActions from '../../../store/ducks/r_logs/actions';

class ReimpressaoCapa extends React.Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 3,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: true,
      withFirstAndLast: true,
      sizePerPage: 5,
      noDataText: 'Não existem dados para exibição.',
      firstPageTitle: 'Ir para primeira página',
      lastPageTitle: 'Ir para última página',
      lastPageText: 'Última página',
      nextPageTitle: 'Próxima página',
      prePageTitle: 'Página anterior',
    };

    this.state = {
      contratosReimpressao: [],
    };

    this.imprimir = this.imprimir.bind(this);
  }

  imprimir() {
    const { data } = dynamicFilterStore.getState().dynamicFilters;
    const selectedData = data.filter((d) => d.isSelected);

    this.setState((prevState) => ({
      ...prevState,
      contratosReimpressao: selectedData,
    }));

    const { logsActions } = this.props;
    if (selectedData && selectedData.length > 0) {
      selectedData.forEach(({ IdContrato, CaixaOriginal, CaixaCopia }) => {
        logsActions.registerRequest({
          service: 'protocolo',
          action: LOGS.ACTIONS_TYPE.RECEPCAO.REIMPRIMIR_CAIXA,
          data: {
            IdContrato,
            CaixaOriginal,
            CaixaCopia,
          },
        });
      });
    } else {
      toast.error('Selecione um contrato para a reimpressão');
    }
  }

  render() {
    const { configs: { cesta } } = dynamicFilterStore.getState().dynamicFilters;
    const { contratosReimpressao } = this.state;
    return (
      <div className="reimpressao-capa">

        <PrintCapa
          reimpressao
          chavesDados={cesta || []}
          itens={contratosReimpressao}
          autoPrint 
          hasCopy 
        />

        <Row className="not-print">
          <Col sm={12}>
            <Card>
              <CardHeader>Reimpressão de Capa</CardHeader>
              <CardBody>
                <FiltroDinamico
                  {...this.props}
                  name="reimpressao-capa"
                  service="protocolo"
                  filterRequired
                  actionsButtons={{
                    reimprimir: this.imprimir,
                  }}
                />

                <div>
                  <Row className="mt-3 row_protocolo">
                    <Col>
                      <GridDinamico
                        {...this.props}
                        tableActions={[{ type: 'checkbox' }]}
                      />
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  logsActions: bindActionCreators(LogsActions, dispatch),
});

export default connect(
  null,
  mapDispatchToProps,
)(ReimpressaoCapa);